import { Routes, Route } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { BuilderPage } from './BuilderPage';
import { SessionsListPage } from './SessionsListPage';
import { TemplatesPage } from './TemplatesPage';

/**
 * Arche wrapper for Builder — handles sub-routing with layout variations:
 * - /:sessionId — full-screen builder editor (no sidebar)
 * - / and /templates — wrapped in ArcheLayout (browsing/listing pages)
 *
 * Note: /preview is handled at the App.tsx level since it needs no auth/layout.
 */
export function BuilderArchePage() {
  return (
    <Routes>
      {/* Builder session editor — full-screen, no sidebar */}
      <Route path="/:sessionId" element={<BuilderPage />} />
      {/* Sessions list and templates — get ArcheLayout */}
      <Route
        path="/*"
        element={
          <ArcheLayout>
            <Routes>
              <Route path="/" element={<SessionsListPage />} />
              <Route path="/templates" element={<TemplatesPage />} />
            </Routes>
          </ArcheLayout>
        }
      />
    </Routes>
  );
}
